// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1i8Hk","productName":"Table_productName__DJe_E"};